import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EstatusLegalesResponse, IGetAllEstatusLegales, IGetEstLegErr, IGetEstLegErrRes } from '@p-p-portafolio/promociones/interfaces/estatus-legales';
import { SwalService } from '@shared/utils/swal.service';
import { EstatusLegalesService } from '@p-p-portafolio/promociones/services/estatus-legales.service';
import { Row } from '@shared/components/generic-table/types/row.type';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { MatDialog } from '@angular/material/dialog';
import { EstatusLegalesFormComponent } from './estatus-legales-form/estatus-legales-form.component';
import Swal from 'sweetalert2';
interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-estatus-legales',
  templateUrl: './estatus-legales.component.html',
  styleUrls: ['./estatus-legales.component.css']
})
export class EstatusLegalesComponent implements OnInit {
  public columns: Column[] = [
    { field: 'estatusLegal', header: 'Estatus' },
    { field: 'diasDues', header: 'Días/Dues' },
    { field: 'minimo', header: 'Mín.' },
    { field: 'maximo', header: 'Max.' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'provision', header: 'Provisión' },
    { field: 'actions', header: 'Acciones' }
  ];

  public dataSource: EstatusLegalesResponse[] = [];
  public loading: boolean = true;

  promocion = '';

  constructor(public dialog: MatDialog, private estatusLegalesService: EstatusLegalesService, private swalService: SwalService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    this.promocion = String(routeParams.get('promocion'));

    this.getDataSource();
  }

  actionHandler(event) {
    var action: 'create' | 'update' | 'delete' = event.action;
    if (action === 'create') {
      this.createAction();
    }

    if (action === 'update') {
      this.updateAction(event.entity);
    }

    if (action == 'delete') {
      this.deleteAction(event.entity);
    }
  }

  goBack() {
    window.history.back();
  }

  createAction(entity?) {
    this.estatusLegalesService.initializeFormGroup();
    const dialogRef = this.dialog.open(EstatusLegalesFormComponent, {
      data: { promocion: this.promocion }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataSource();
    });
  }

  updateAction(entity: EstatusLegalesResponse) {
    const dialogRef = this.dialog.open(EstatusLegalesFormComponent, {
      data: { promocion: this.promocion, elemento: entity }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getDataSource();
    });
  }

  deleteAction(entity) {
    entity.sPromocion = this.promocion;

    const dialogRef = this.dialog.open(ConfirmDeletionComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.callDeleteService(entity);
      }
    });
  }

  callDeleteService(entity: EstatusLegalesResponse) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el estatus ${entity.estatusLegal}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      iconColor: '#d33',
      confirmButtonColor: '#d33',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      const payload: IGetEstLegErr = {
        que: 3, // El 3 indica que se trata de un borrado
        promocion: this.promocion,
        estatus: entity.estatusLegal,
        diasDues: entity.diasDues,
        minimo: entity.minimo,
        maximo: entity.maximo,
        descripcion: entity.descripcion,
        provision: entity.provision,
        provisionInt: entity.provisionInt,
        clasCartera: entity.clasCartera,
        porcGarantia: entity.porcGarantia,
        origenReserva: entity.origenReserva,
        iPorDefinir: 0
      };
      this.estatusLegalesService.GetEstLegErr(payload).subscribe(
        (res: IGetEstLegErrRes) => {
          if (res.success) {
            this.swalService.success('El Estado Legal se ha eliminado correctamente');
            this.getDataSource();
          } else {
            this.swalService.error('Ocurrió un error al crear el Estado Legal');
          }
        },
        (error) => {
          this.swalService.error(error);
        }
      );
    });
  }

  getDataSource() {
    const payload: IGetAllEstatusLegales = {
      promocion: this.promocion,
      estatus: '',
      diasDues: 0,
      minimo: 0,
      maximo: 0,
      descripcion: '',
      provision: 0,
      provisionInt: 0,
      clasCartera: 0,
      porcGarantia: 0,
      origenReserva: 0,
      iPorDefinir: 0
    };
    this.estatusLegalesService.getAll(payload).subscribe((res) => {
      this.dataSource = res.data;
      this.loading = false;
    });
  }
}
